// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, COMMON_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/faq'

const state = {}

const mutations = {}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 여행가방 > 여행안내소 > 자주묻는질문 카테고리 목록조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getFaqForCtg ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/faqs/{ctg}`, payload)
  }
}

export default { state, mutations, actions }
